import React from "react";

const CopyRight = () => {
  return (
    <div className="flex flex-col items-start sm:px-16 p-6">
      <h1 className="text-[1.9rem] font-bold tracking-wide ">
        E.
        <span className="text-[#01A7D1] ">
          {" "}
          COPYRIGHT INFRINGEMENT TAKEDOWN PROCEDURE
        </span>
      </h1>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        Yostel has high regard for intellectual property and expects the same
        level of standard to be employed by its users. Yostel may, in
        appropriate circumstances and at its discretion, terminate the Account
        or prohibit access to the Platform of users who infringe upon the
        intellectual property rights of others.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        If you believe that your work has copied and posted on the Platform in a
        way that constitutes copyright infringement and/or trademark
        infringement been, please send the following information to us at
        hello.yostel@gmail.com
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        (i) identification of the copyrighted and/or trademarked work claimed to
        have been infringed, or, if multiple works at a single online site are
        covered by a single notification, a representative list of such works at
        that site.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        (ii) identification of the material that is claimed to be infringing or
        to be the subject of infringing activity and that is to be removed or
        access to which is to be disabled at the Platform, and information
        reasonably sufficient to permit Yostel to locate the material;
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        (iii) a written statement that you have a good faith belief that the
        disputed use is not authorized by the copyright and/or trademark owner,
        its agent, or the law.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        (iv) information reasonably sufficient to permit Yostel to contact you
        as the complaining party, such as an address, telephone number, and, if
        available, an electronic mail address at which you may be contacted.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        (v) an electronic or physical signature of the person authorized to act
        on behalf of the owner of an exclusive.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        (vi) a statement by you, made under penalty of perjury, that the
        information in your report is accurate and that you are the owner of the
        exclusive right or authorized to act on the behalf of the owner of the
        exclusive right. A statement by you consisting of the foregoing points
        is referred to herein as the "Notice."
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        Only the intellectual property rights owner is permitted to report
        potentially infringing items through Yostel’s reporting system set forth
        above. If you are not the intellectual property rights owner, you should
        contact the intellectual property rights owner and they can choose
        whether to use the procedures set forth in these Terms of Use.
      </p>
    </div>
  );
};

export default CopyRight;
